import { Component } from 'react';
import PropTypes from 'prop-types';

function toggleScrollClass(isDrawerOpen) {
    if (isDrawerOpen) {
        document.body.classList.add('bs-bodyScroll');
    } else {
        document.body.classList.remove('bs-bodyScroll')
    }
}
export class BodyScroll extends Component {

    componentDidMount() {
        toggleScrollClass(this.props.isDrawerOpen);
    }

    componentWillReceiveProps(nextProps) {
        toggleScrollClass(nextProps.isDrawerOpen);
    }

    componentWillUnmount() {
        document.body.classList.remove('bs-bodyScroll');
    }

    render() {
        return null;
    }
}

BodyScroll.defaultProps = {
    isDrawerOpen: false,
}

BodyScroll.propTypes = {
    isDrawerOpen: PropTypes.bool,
}

export default BodyScroll;



// WEBPACK FOOTER //
// /src/js/drawer/components/BodyScroll/BodyScroll.jsx